import { Injectable } from '@angular/core';
import { localStorage } from 'src/shared/models/local-storage.model';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';

export interface ILocalStorage {
	getItem: (key: string) => any;
}

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService implements localStorage {
	protected subjects: { [key: string]: BehaviorSubject<any> } = {};

	getItem = (key: string) => this.select(key);

	select(key: string, defaultValue: any = null): BehaviorSubject<any> {
		if (this.subjects.hasOwnProperty(key)) {
			return this.subjects[key];
		}

		if (!window.localStorage.getItem(key) && defaultValue) {
			window.localStorage.setItem(key, JSON.stringify(defaultValue));
		}

		const value = window.localStorage.getItem(key)
			? JSON.parse(window.localStorage.getItem(key))
			: defaultValue;

		return (this.subjects[key] = new BehaviorSubject(value));
	}

	set(key: string, value: any): Observable<any> {
		window.localStorage.setItem(key, JSON.stringify(value));

		if (this.subjects.hasOwnProperty(key)) {
			this.subjects[key].next(value);
		} else {
			this.subjects[key] = new BehaviorSubject(value);
		}

		return this.subjects[key].asObservable();
	}

	remove(key: string): void {
		window.localStorage.removeItem(key);

		if (this.subjects.hasOwnProperty(key)) {
			this.subjects[key].next(null);
		}
	}

	has(key: string): boolean {
		const value = this.getItem(key).value;
		return value && value !== 'null';
	}
}
